module.exports = __webpack_public_path__ + "components/weather-icon/static/daythunderstorm-fc45828068e3aada84e4a91c8976fc4b.webp";